module.exports = __webpack_public_path__ + "images/faviconx64.png";